import { ReactNode } from 'react';
import { ReadonlyStack } from '@issuemanager/apps/client/components';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Props = {
  [key: string]: ReactNode;
};

export function IssueFields({
  severity,
  dueDate,
  govmapGroups,
  ownerId,
  approverId,
  managerId,
}: Props) {
  const { t } = useTranslation('issue');

  return (
    <Stack data-testid='details' spacing={3}>
      <Typography variant='h3' fontWeight='medium'>
        {t('form.sections.assignments')}
      </Typography>
      <ReadonlyStack>
        <Box flex={1}>
          <Stack spacing={3}>
            {severity}
            {dueDate}
            {govmapGroups}
          </Stack>
        </Box>
        <Box flex={1}>
          <Stack spacing={3}>
            {managerId}
            {ownerId}
            {approverId}
          </Stack>
        </Box>
      </ReadonlyStack>
    </Stack>
  );
}
